import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from "rxjs";
import { Location } from '@angular/common';

@Component({
  selector: 'app-card-replacement-success',
  templateUrl: './card-replacement-success.component.html',
  standalone:false,
  styleUrls: ['./card-replacement-success.component.scss']
})
export class CardReplacementSuccessComponent implements OnInit {

  constructor(private location: Location, private router:Router,private _route:ActivatedRoute) { }
  pendingRequest:boolean=false
  letterRequest:boolean=false
  RefId:string="";
  ReplaceCard:boolean=false;
  DigiReplaceCard:boolean=false;
  PhysicalReq:boolean=false;


  Email:string="";
  

  ngOnInit(): void {

    this._route.queryParams.subscribe(params => {
      if (params) {
        
       if(params['pendingRequest']){
          this.pendingRequest=params['pendingRequest'];

        }
        if(params['letterRequest']){
          this.letterRequest=params['letterRequest'];

        }
        if(params['Refid']){

          this.RefId=params['Refid'];
        }
        if(params['ReplaceCard']){

          this.ReplaceCard=params['ReplaceCard'];


        }if(params['DigiReplaceCard']){

          this.DigiReplaceCard=params['DigiReplaceCard'];

        }
        if(params['PhysicalReq']){

          this.PhysicalReq = params['PhysicalReq'];
        }
        if(params['email']){
          this.Email=params['email']
        }

      }
    });
  }


  Dashboard(){
    this.router.navigateByUrl('/Dashboard');
  }

}
